import { Component } from '@angular/core';

@Component({
  selector: 'allas-como-cotizar-por-whatsapp',
  imports: [],
  template: `
    <section class="grid grid-cols-1 xl:grid-cols-2 gap-4 mt-12">
      <article
        class="bg-[#db0000] flex flex-col items-center justify-center p-6 xl:p-14 px-2 xl:px-16"
      >
        <span class="text-3xl xl:text-5xl font-bold fs-condensed text-white">
          ¿COMO COTIZAR?
        </span>
        <p
          class="text-white text-md xl:text-2xl text-center font-light fs-condensed"
        >
          Proceso súper simple <br />
          en solo <strong class="font-bold fs-condensed">3 pasos</strong>
        </p>

        <div
          class="col-span-12 xl:col-span-6 flex flex-col gap-8 mt-6 xl:mt-8 mb-12"
        >
          <div class="flex gap-6">
            <span
              class="min-w-8 min-h-8 size-8 xl:min-w-12 xl:min-h-12 xl:size-12 flex items-center justify-center border-2 xl:border-4 border-white rounded-xl"
            >
              <span
                class="text-xl xl:text-3xl font-bold fs-condensed text-white"
              >
                1
              </span>
            </span>
            <span class="flex flex-col">
              <span class="text-xs xl:text-xl font-light text-white">
                <span class="font-medium fs-condensed">
                  Envía tu consulta:
                </span>
                <span
                  class="opacity-90 text-xs xl:text-base [&_br]:hidden xl:[&_br]:block"
                >
                  Escribenos por WhatsApp con el repuesto que <br />
                  necesitas o envía una foto; envianos la información de tu
                  vehículo.
                </span>
              </span>
              <div class="w-full h-[1px] bg-white mt-2"></div>
            </span>
          </div>
          <div class="flex gap-6">
            <span
              class="min-w-8 min-h-8 size-8 xl:min-w-12 xl:min-h-12 xl:size-12 flex items-center justify-center border-2 xl:border-4 border-white rounded-xl"
            >
              <span
                class="text-xl xl:text-3xl font-bold fs-condensed text-white"
              >
                2
              </span>
            </span>
            <span class="flex flex-col">
              <span class="text-xs xl:text-xl font-light text-white">
                <span class="font-medium fs-condensed">
                  Recibe tu cotización:
                </span>
                <span
                  class="opacity-90 text-xs xl:text-base [&_br]:hidden xl:[&_br]:block"
                >
                  Te respondemos con precio, disponibilidad<br />
                  y tiempo de entrega.
                </span>
              </span>
              <div class="w-full h-[1px] bg-white mt-2"></div>
            </span>
          </div>
          <div class="flex gap-6">
            <span
              class="min-w-8 min-h-8 size-8 xl:min-w-12 xl:min-h-12 xl:size-12 flex items-center justify-center border-2 xl:border-4 border-white rounded-xl"
            >
              <span
                class="text-xl xl:text-3xl font-bold fs-condensed text-white"
              >
                3
              </span>
            </span>
            <span class="flex flex-col">
              <span class="text-xs xl:text-xl font-light text-white">
                <span class="font-medium fs-condensed">
                  Decide cuando quieras:
                </span>
                <span
                  class="opacity-90 text-xs xl:text-base [&_br]:hidden xl:[&_br]:block"
                >
                  Puedes apartar el producto, visitarnos en<br />
                  tienda o seguir consultando.
                </span>
              </span>
            </span>
          </div>
        </div>
      </article>
      <article class="flex flex-col">
        <div
          class="bg-cover bg-center bg-no-repeat grid grid-cols-12 p-8 py-8 xl:py-24"
          style="background-image: url('/images/services/cotizar-por-whatsapp/atencion-inmediata.webp');"
        >
          <span
            class="col-start-6 col-end-13 text-2xl xl:text-4xl font-bold fs-condensed text-white flex items-center justify-center text-center"
          >
            Atención <br />
            Inmediata
          </span>
        </div>
        <div
          class="bg-[#f3f4f6] flex flex-col items-center justify-center py-8 gap-8 flex-auto"
        >
          <article class="grid grid-cols-12 gap-2 w-3/4">
            <span class="col-span-3 flex items-center justify-center">
              <img
                src="/allas-icons/calendar.svg"
                alt="calendar"
                class="h-12 xl:h-16 w-auto"
              />
            </span>
            <span class="flex flex-col col-span-9">
              <span
                class="text-base xl:text-xl font-black fs-condensed text-appBlack"
              >
                Horario de atención
              </span>
              <p
                class="text-xs xl:text-base font-light [&_br]:hidden xl:[&_br]:block"
              >
                Lunes a Viernes: 8:00 AM - 10:00 PM; Sábados: <br />
                8:00 AM - 9:00 PM; Domingos de 4:00 PM a 8 PM
              </p>
            </span>
          </article>
          <article class="grid grid-cols-12 gap-2 w-3/4">
            <span class="col-span-3 flex items-center justify-center">
              <img
                src="/allas-icons/double-check-w-stars.svg"
                alt="double-check-w-stars"
                class="h-12 xl:h-16 w-auto"
              />
            </span>
            <span class="flex flex-col col-span-9">
              <span
                class="text-base xl:text-xl font-black fs-condensed text-appBlack"
              >
                Respuesta Garantizada
              </span>
              <p
                class="text-xs xl:text-base font-light [&_br]:hidden xl:[&_br]:block"
              >
                Te respondemos en menos de 30 <br />
                minutos durante horario comercial.
              </p>
            </span>
          </article>
        </div>
      </article>
    </section>
  `,
})
export class ComoCotizarPorWhatsapp {}
